import { isArray } from "lodash";
import React from "react";
import { CSVLink as ReactCSV } from "react-csv";

import { Icon } from "../components/Icon";
import { cn } from "../utils/styling";

function CSVLink({ className, color, data }: { className?: string; color?: string; data: unknown[] }) {
  if (isArray(data))
    return (
      <ReactCSV data={data}>
        <div
          className={cn(
            "cancelDrag cursor-pointer rounded  hover:outline hover:outline-1 hover:outline-ds-focus",
            className
          )}
        >
          <Icon color={color} iconName="Download" size="md" svgClassName="transition" />
        </div>
      </ReactCSV>
    );
}

export default React.memo(CSVLink);
